import EventEmitter from 'events';
import { useCallback, useRef } from 'react';
import * as ReactDOM from 'react-dom/client';
import { CameraPreview } from '@capacitor-my-custom/camera-preview';
import { useUnmount } from 'ahooks';
import { Camera } from '@capacitor/camera';
import { CameraMarker, Toast } from '@/components';
import { hiddenWholePage } from './useScanQRCode';

export const CAMERA_MARKER_DOM_ID = 'camera-marker-container';

export const CustomCameraEventBus = new EventEmitter();

interface Props {
  buttonPosition?: 'left' | 'right';
  shouldTransFromFrontImage?: boolean;
}

interface MarkerConfig {
  url: string;
  width: string | number;
}

/**
 * 自定义相机拍照
 */
const useCustomCamera = (props?: Props) => {
  const { buttonPosition = 'right', shouldTransFromFrontImage = false } = props || {};

  const rootRef = useRef<ReactDOM.Root>(null);

  useUnmount(() => {
    CustomCameraEventBus.removeAllListeners();
  });

  const createMarkerDom = useCallback(
    (markerConfig: MarkerConfig) => {
      const container = document.createElement('div');
      container.id = CAMERA_MARKER_DOM_ID;
      document.body.appendChild(container);

      rootRef.current = ReactDOM.createRoot(document.getElementById(CAMERA_MARKER_DOM_ID));
      rootRef.current.render(
        <CameraMarker
          shouldTransFromFrontImage={shouldTransFromFrontImage}
          buttonPosition={buttonPosition}
          rootRef={rootRef}
          markerConfig={markerConfig}
        />
      );
    },
    [buttonPosition, shouldTransFromFrontImage]
  );

  const handleScan = useCallback(
    (markerConfig: MarkerConfig) => {
      return new Promise<{ url: string }>(async (resolve, reject) => {
        const permission = await Camera.checkPermissions();

        if (permission.camera === 'denied') {
          Toast.show('请先打开相机权限');
          return;
        } else if (permission.camera !== 'granted') {
          const requstResult = await Camera.requestPermissions({ permissions: ['camera'] });
          if (requstResult.camera !== 'granted') {
            Toast.show('请先打开相机权限');
            return;
          }
        }

        hiddenWholePage();
        createMarkerDom(markerConfig);
        await CameraPreview.start({
          toBack: true,
          lockAndroidOrientation: true,
        });

        CustomCameraEventBus.once('cameraShootResult', (path: string) => {
          resolve({ url: path });
        });
      });
    },
    [createMarkerDom]
  );

  return {
    handleScan,
  };
};

export default useCustomCamera;
